import axios from "axios";

export async function search(
  string: string = "*",
  collection: string = "hikes"
): Promise<Object | null> {
  const axiosClient = axios.create({
    headers: {
      'x-typesense-api-key': window.typesenseSearchApiKey,
    },
  })
  let url = createTypesenseURL(string, collection)

  try {
    let response = await axiosClient(url)
    return response.data as Object
  } catch (e) {
    return null
  }
}

function createTypesenseURL(
  query: string = "*",
  collection: string = "trails"
): string {
  let urlBase = 'https://' + window.typesenseUrl + `/collections/${collection}/documents/search`
  const url = new URL(urlBase);

  url.searchParams.append("q", query);
  url.searchParams.append("per_page", "40");
  url.searchParams.append("query_by", "name,short_address")
  return url.href
}
